module.exports = __webpack_public_path__ + "img/people-settings.e858d654.svg";